import { Search, X } from 'lucide-react';
import { useSearch } from '../context/SearchContext';
import { useT } from '../i18n';

// The project search of the Pipeline and Portfolio pages, sitting in each
// page's own filter row next to the other filters (it used to live in the
// top bar). The term itself stays app-wide (SearchContext), so it survives a
// switch between the two pages and is cleared when leaving them (AppShell).
export function ProjectSearchBox() {
  const { t } = useT();
  const { searchTerm, setSearchTerm } = useSearch();
  return (
    <div className="header-search toolbar-search">
      <Search size={14} className="header-search-icon" />
      <input
        className="header-search-input"
        type="text"
        placeholder={t('shell.searchProjects')}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      {searchTerm && (
        <button type="button" className="header-search-clear" onClick={() => setSearchTerm('')} title={t('shell.clearSearch')}>
          <X size={12} />
        </button>
      )}
    </div>
  );
}
